/**
 * @generated SignedSource<<413e5780de08833a05f519000579cca2>>
 * @relayHash 2ebb96e570b0a02a0b2e238872409bba
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2ebb96e570b0a02a0b2e238872409bba

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DenyTakeOverPatientFileLockInput = {
  patientId: string;
};
export type useDenyTakeOverPatientMutation$variables = {
  input: DenyTakeOverPatientFileLockInput;
};
export type useDenyTakeOverPatientMutation$data = {
  readonly denyTakeOverPatientFileLock: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly patientFileLockOutput: {
      readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockOutputFragment">;
    } | null;
  };
};
export type useDenyTakeOverPatientMutation = {
  response: useDenyTakeOverPatientMutation$data;
  variables: useDenyTakeOverPatientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDenyTakeOverPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DenyTakeOverPatientFileLockPayload",
        "kind": "LinkedField",
        "name": "denyTakeOverPatientFileLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLockOutput",
            "kind": "LinkedField",
            "name": "patientFileLockOutput",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PatientFileLockOutputFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDenyTakeOverPatientMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DenyTakeOverPatientFileLockPayload",
        "kind": "LinkedField",
        "name": "denyTakeOverPatientFileLock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PatientFileLockOutput",
            "kind": "LinkedField",
            "name": "patientFileLockOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PatientFileLock",
                "kind": "LinkedField",
                "name": "patientFileLock",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "patientId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockedBy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockRequestedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lockRequestedBy",
                    "storageKey": null
                  },
                  {
                    "alias": "inContextOfAppointment",
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "appointment",
                    "plural": false,
                    "selections": [
                      (v3/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestInContextOfAppointmentId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Appointment",
                "kind": "LinkedField",
                "name": "inContextOfAppointment",
                "plural": false,
                "selections": [
                  (v3/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCompleted",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AppointmentChatDetails",
                    "kind": "LinkedField",
                    "name": "chatDetails",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "chatThreadId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2ebb96e570b0a02a0b2e238872409bba",
    "metadata": {},
    "name": "useDenyTakeOverPatientMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "32320eb2960bd930557ffe74f4b79d55";

export default node;
